import { Component } from '@theme/component';

/** Reveal on scroll de sections/mox-licencias.liquid. Sin JS la sección se ve directo. */
class MoxLicReveal extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.classList.add('mox-lic--js');

    if (!('IntersectionObserver' in window)) {
      this.#show();
      return;
    }

    this.#intersectionObserver = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.#show();
      },
      { threshold: 0.15 }
    );
    this.#intersectionObserver.observe(this);

    // ya visible al cargar: no esperar al observer
    requestAnimationFrame(() => {
      if (this.getBoundingClientRect().top < window.innerHeight * 0.9) {
        this.#show();
      }
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#intersectionObserver?.disconnect();
  }

  #show() {
    this.classList.add('is-inview');
    this.#intersectionObserver?.disconnect();
  }

  /** @type {IntersectionObserver | undefined} */
  #intersectionObserver;
}

if (!customElements.get('mox-lic-reveal')) {
  customElements.define('mox-lic-reveal', MoxLicReveal);
}
